module.exports = __webpack_public_path__ + "img/logo header.ed39b5f3.svg";